import React, { Component } from "react";
import NavBar from "../components/NavBar";
import Sidebar from "./components/Sidebar";
import ServiceGallery from "./components/ServiceGallery"
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
class LearningSupport extends Component {
  render() {
    return (
      <div>
        {/* Navigation bar */}
        <NavBar />

        {/* breadcrumb */}
        {/*====================  breadcrumb area ====================*/}
        <div
          className="breadcrumb-area breadcrumb-bg"
          style={{
            backgroundImage: `url(assets/img/backgrounds/funfact-bg.jpg)`
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="page-banner text-center">
                  <h1>Learning Support</h1>
                  <ul className="page-breadcrumb">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>
                      <a href={`${process.env.PUBLIC_URL}/services`}>
                        Services
                      </a>
                    </li>
                    <li>Learning Support</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*====================  End of breadcrumb area  ====================*/}

        <div className="page-wrapper section-space--inner--120">
          {/*Service section start*/}
          <div className="service-section">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 col-12 order-1 order-lg-2">
                  <div className="service-details">
                    {/* service gallery */}
                    <ServiceGallery />

                    <div className="content section-space--top--30">
                      <h2>Learning Support</h2>

                      <p>
                        Learning Support is a specialized educational service designed to help
                        children overcome learning challenges and achieve their academic
                        potential. Every child learns differently, and some may require
                        additional guidance, structured teaching, and individualized
                        strategies to understand concepts, develop skills, and succeed
                        in school. Our Learning Support program provides personalized
                        interventions that address each child’s unique learning needs
                        while building confidence, motivation, and a love for learning.
                      </p>

                      <p>
                        The program focuses on strengthening essential academic skills
                        such as reading, writing, spelling, mathematics, comprehension,
                        attention, memory, problem-solving, and study skills. Individualized
                        learning plans are developed after understanding each child’s
                        strengths, areas of difficulty, and learning style. This
                        personalized approach ensures that every child receives
                        the right support at the right pace, making learning meaningful
                        and enjoyable.
                      </p>

                      <h3 className="section-space--top--50">Our Learning Approach</h3>

                      <p>
                        Our educators use evidence-based teaching methods, multisensory
                        instruction, activity-based learning, visual supports, and
                        interactive educational techniques to make concepts easier to
                        understand and retain. Along with academic improvement, the
                        program encourages critical thinking, organization,
                        concentration, self-confidence, and independent learning skills
                        that help children perform successfully both inside and outside
                        the classroom.
                      </p>
                      <p>
                        Learning Support is beneficial for children with learning disabilities,
                        developmental delays, ADHD, autism spectrum disorder,
                        slow learning abilities, and those experiencing academic
                        difficulties. We believe that collaboration between educators,
                        therapists, parents, and schools plays a vital role in a child’s
                        progress. By working together, we create a consistent learning
                        environment that encourages growth and long-term success.
                      </p>

                      <h3 className="section-space--top--50">Conclusion</h3>
                      <p>
                        At Shakuntla Learn and Fly Foundation, we are committed to helping
                        every child become a confident and independent learner. Through
                        individualized support, compassionate guidance, and evidence-based
                        educational practices, we empower children to overcome learning
                        challenges, discover their strengths, and achieve their fullest
                        potential. Our goal is to inspire every child to learn with
                        confidence, grow with purpose, and move towards a brighter future.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-12 order-2 order-lg-1">
                  <Sidebar />
                </div>
              </div>
            </div>
          </div>
          {/*Service section end*/}
        </div>

        {/* Footer */}
        <Footer />

        {/* Mobile Menu */}
        <MobileMenu />
      </div>
    );
  }
}

export default LearningSupport;
